export default __webpack_public_path__ + "static/media/AashiqueAhmedIqbal.5efeb62a.png";